import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=5f998a8e&"
import script from "./Accounts.vue?vue&type=script&lang=ts&"
export * from "./Accounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/_locales/ManageAccount.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Fadministration%2FAccounts.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports